<template>
  <v-row no-gutters>
    <v-col
      v-if="minimal"
      cols="2"
      :class="light ? 'h-b-light' : 'h-b'"
    />
    <v-col
      cols="8"
      :class="light ? 'h-b-light' : 'h-b'"
    >
      <v-row no-gutters>
        <h-btn
          v-for="i in 9"
          :key="`kn${i}`"
          cols="4"
          height="65"
          large
          :label="i"
          @clicked="add"
        />
        <h-btn
          cols="4"
          height="65"
          large
          :icon="icons.backspaceOutline"
          @clicked="del"
        />
        <h-btn
          cols="4"
          height="65"
          large
          label="0"
          @clicked="add"
        />
        <h-btn
          v-if="! minimal"
          cols="4"
          height="65"
          large
          label="00"
          @clicked="add"
        />
      </v-row>
    </v-col>
    <v-col
      v-if="minimal"
      cols="2"
      :class="light ? 'h-b-light' : 'h-b'"
    />
    <v-col v-else cols="4">
      <v-row
        no-gutters
        :class="light ? 'h-b-light' : 'h-b'"
      >
        <h-btn
          v-for="(money, i) in monies"
          :key="`kc${i}`"
          cols="6"
          height="51"
          :label="money"
          @clicked="sum"
          :class="light ? 'h-tl-light' : 'h-tl'"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import UsesIcons from '@/Mixins/UsesIcons'
  import HBtn from './CalculatorBtn'

  export default {
    mixins: [
      UsesIcons,
    ],

    components: {
      HBtn,
    },

    props: {
      value: {
        required: true,
        type: String,
      },
      light: {
        required: false,
        type: Boolean,
        default: false,
      },
      minimal: {
        required: false,
        type: Boolean,
        default: false,
      },
      max: {
        required: false,
        type: Number,
        default: 999999999999,
      },
    },

    data: () => ({
      monies: ['0.05', '0.10', '0.20', '0.50', '1', '2', '5', '10', '20', '50'],
    }),

    computed: {
      floatValue () {
        return parseInt(this.value) / 100
      },
      overflow () {
        return this.floatValue >= this.max
      },
    },

    methods: {
      add (v) {
        if (this.overflow) {
          return
        }
        this.set(`${this.value}${v}`)
      },
      del () {
        this.set(this.value.length > 1
          ? this.value.slice(0, -1)
          : '0'
        )
      },
      sum (v) {
        if (this.overflow) {
          return
        }
        const newValue = this.floatValue + parseFloat(v)
        this.set(String(Math.round(newValue * 100)))
      },
      set (v) {
        this.$emit('input', v)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .h-tl {
    border-top: 1px #292321 solid !important;
    border-left: 1px #292321 solid !important;
  }
  .h-tl-light {
    border-top: 1px #e0e0e0 solid !important;
    border-left: 1px #e0e0e0 solid !important;
  }
  .h-b {
    border-bottom: 1px #292321 solid !important;
  }
  .h-b-light {
    border-bottom: 1px #e0e0e0 solid !important;
  }
</style>
